import type { ApiResponse, AuthUser, UpdateProfilePayload } from '@alqove/types';
import type { AlqoveClient } from '../client';

export function createUserEndpoints(client: AlqoveClient) {
  return {
    getProfile() {
      return client.get<ApiResponse<AuthUser>>('/v1/users/me');
    },

    updateProfile(payload: UpdateProfilePayload) {
      return client.put<ApiResponse<AuthUser>>('/v1/users/me', payload);
    },
  };
}
